import { api } from 'boot/axios';
import { defineStore } from 'pinia';
import { getResponseData } from 'utils';
import { trace } from 'boot/trace';
import { useRegionsStore } from 'stores/regions-store';
import { TNormalizedOrganisationShort } from 'types';

type State = {
  organisations: TNormalizedOrganisationShort[];
};

export const useOrganisationsStore = defineStore('organisations', {
  state: (): State => ({
    organisations: [],
  }),
  actions: {
    cacheOrganisationData(data: TNormalizedOrganisationShort[]) {
      if (data) {
        localStorage.setItem('organisations', JSON.stringify(data));
        trace('Caching organisation data:', 'info', data);
      }
    },
    fetchOrganisationData() {
      return api.get('/api/v1/organisations');
    },
    async getOrganisations() {
      const regionsStore = useRegionsStore();

      // Load from cache.
      const cachedOrganisationData = localStorage.getItem('organisations');
      if (cachedOrganisationData) {
        const data = JSON.parse(
          cachedOrganisationData
        ) as TNormalizedOrganisationShort[];
        trace('Cached organisation data found:', 'info', data);
        this.organisations = data;
        regionsStore.extractDataDictionaries(data);

        // Ensure we update.
        this.fetchOrganisationData().then((response) => {
          const organisationData = getResponseData(
            response
          ) as TNormalizedOrganisationShort[];
          this.organisations = organisationData;
          this.cacheOrganisationData(organisationData);
          regionsStore.extractDataDictionaries(organisationData);
        });
        return;
      }

      // No cache.
      trace('Fetching fresh organisation data:', 'info');
      const response = await this.fetchOrganisationData();
      const organisationData = getResponseData(response);
      this.organisations = organisationData;
      this.cacheOrganisationData(organisationData);
      regionsStore.extractDataDictionaries(organisationData);
    },
    clear() {
      this.organisations = [];
    },
  },
});
